import { createFeatureSelector, createSelector } from "@ngrx/store";
import { EntityTagState, selectAll } from "./entity-tag.reducer";

export const selectEntityTagState = createFeatureSelector<EntityTagState>('entityTagState');
export const selectEntitiesByTag = createSelector(
    selectEntityTagState,
    (state: EntityTagState) => selectAll(state)
);
export const selectIsLoading = createSelector(selectEntityTagState, ({ isLoading }: EntityTagState) => isLoading);